import { render, staticRenderFns } from "./FamilyImg.vue?vue&type=template&id=6d6d87b7&scoped=true&"
import script from "./FamilyImg.vue?vue&type=script&lang=ts&"
export * from "./FamilyImg.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyImg.vue?vue&type=style&index=0&id=6d6d87b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6d87b7",
  null
  
)

export default component.exports